import React from 'react'
import { Input } from '@cvg/react-components'

import { SORT_OPTIONS } from '@utils/constants'

import { useFiltersContext } from '@contexts/FilterContext'

const Sort = () => {
  const { sortBy, setSortBy } = useFiltersContext()

  return (
    <Input
      name='sort'
      onChange={e => setSortBy({ sortBy: e.target.value })}
      placeholder='Sort by'
      type='select'
      value={sortBy}
    >
      {Object.entries(SORT_OPTIONS).map(([label, value]) => (
        <option key={label} value={value}>
          {label}
        </option>
      ))}
    </Input>
  )
}

export default Sort
